<div class="card" *ngIf="data">
  <p-table class="custom-table-container" [scrollable]="true" [scrollHeight]="scrollHeight" [autoLayout]="true"
    showGridlines="true" [value]="data.items">
    <ng-template pTemplate="header">
      <tr class="caption-container" #headerContainer>
        <th [attr.colspan]="dataReport.headers.length" class="p-0 border-0">
          <div class="card p-2" *ngIf="dataReport.captionDescription.length || dataReport.captionFilters.length">
            <div class="caption caption-description ">
              <span *ngFor="let description of dataReport.captionDescription">
                {{ description }}
              </span>
            </div>
            <div class="caption caption-filters">
              <span *ngFor="let filter of dataReport.captionFilters">
                {{ filter }}
              </span>
            </div>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td class="p-0 border-0">
          <ng-container *ngIf="item?.receipt as receipt">
            <!-- TABLA RECIBOS DE CAJA -->
            <table class="table-receipt mt-1">
              <thead>
                <tr>
                  <th *ngFor="let h of data.receiptHeader" class="th-nowrap th-cash-receipts">
                    {{ h }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">{{ receipt.consecutive }}</td>
                  <td class="text-center">{{ receipt.date }}</td>
                  <td class="text-start td-nowrap col-client ellipsis-text">
                    {{ receipt.client }}
                  </td>
                  <td class="text-start td-nowrap col-concept ellipsis-text">
                    {{ receipt.concept }}
                  </td>
                  <td class="text-end">{{ receipt.paymentValue | currency:'':'' }}</td>
                  <td class="text-end">{{ receipt.advanceValue | currency:'':'' }}</td>
                  <td class="text-end">{{ receipt.refundValue | currency:'':'' }}</td>
                  <td class="text-end">{{ receipt.utilizationValue | currency:'':'' }}</td>
                  <td class="text-end">{{ receipt.commissionValue | currency:'':'' }}</td>
                  <td class="text-end">{{ receipt.totalValue | currency:'':'' }}</td>
                </tr>
              </tbody>
            </table>
            <!-- TABLA FACTURAS -->
            <ng-container *ngIf="item.invoices as invoices">
              <table class="table-invoices mt-1">
                <thead>
                  <tr>
                    <th *ngFor="let h of data.invoiceHeader" class="th-invoices">
                      {{ h }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let inv of invoices.rows">
                    <td class="text-center">{{ inv.document }}</td>
                    <td class="text-center">{{ inv.type }}</td>
                    <td class="text-end">{{ inv.subtotal | currency:'':'' }}</td>
                    <td class="text-end">{{ inv.reteFuenteValue | currency:'':'' }}</td>
                    <td class="text-end">{{ inv.reteIvaValue | currency:'':'' }}</td>
                    <td class="text-end">{{ inv.reteIcaValue | currency:'':'' }}</td>
                    <td class="text-end">{{ inv.otherTaxes | currency:'':'' }}</td>
                    <td class="text-end">{{ inv.discountValue | currency:'':'' }}</td>
                    <td class="text-end">{{ inv.paidValue | currency:'':'' }}</td>
                  </tr>
                </tbody>
                <tfoot *ngIf="invoices.totals as totals">
                  <tr>
                    <td colspan="2"><strong>Totales:</strong></td>
                    <td class="text-end">
                      {{ totals.subtotal | currency:'':'' }}
                    </td>
                    <td class="text-end">
                      {{ totals.reteFuenteValue | currency:'':'' }}
                    </td>
                    <td class="text-end">
                      {{ totals.reteIvaValue | currency:'':'' }}
                    </td>
                    <td class="text-end">
                      {{ totals.reteIcaValue | currency:'':'' }}
                    </td>
                    <td class="text-end">
                      {{ totals.otherTaxes | currency:'':'' }}
                    </td>
                    <td class="text-end">
                      {{ totals.discountValue | currency:'':'' }}
                    </td>
                    <td class="text-end">
                      {{ totals.paidValue | currency:'':'' }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </ng-container>
            <!-- TABLA FORMAS DE PAGO -->
            <ng-container *ngIf="item.payments?.rows as pays">
              <table class="table-payments mt-1">
                <thead>
                  <tr>
                    <th *ngFor="let h of data.paymentHeader" class="th-nowrap th-payments">
                      {{ h }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let pay of pays">
                    <td class="text-center">{{ pay.wayToPay }}</td>
                    <td class="text-start td-nowrap col-payment-description">
                      <span class="ellipsis-text">
                        {{ pay.description }}
                      </span>
                    </td>
                    <td class="text-end">
                      {{ pay.paidValue | currency:'':'' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>